import { FeedbackCompaniesComponent } from './feedback-companies/feedback-companies.component';
import { EmailCompaniesComponent } from './email-companies/email-companies.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { CompaniesComponent } from './companies/companies.component';
import { CompanyDetailsComponent } from './company-details/company-details.component';
import { CompaniesRfidBulkuploadComponent } from './companies-rfid-bulkupload/companies-rfid-bulkupload.component';
import { CompaniesRfidBulkuploadPreviewComponent } from './companies-rfid-bulkupload-preview/companies-rfid-bulkupload-preview.component';

const routes: Routes = [
  {
    path: 'companies-list',
    // component : MeetingRoomListComponent,
    children: [
      { path: '', component: CompaniesComponent },
      { path: 'company-details', component: CompanyDetailsComponent },
      { path: 'email', component: EmailCompaniesComponent },
      { path: 'feedback', component: FeedbackCompaniesComponent },
      { path: 'rfid-bulk-upload', component: CompaniesRfidBulkuploadComponent },
      { path: 'rfid-bulk-upload-preview', component: CompaniesRfidBulkuploadPreviewComponent },
    ]
  }

];
@NgModule({
  declarations: [],
  imports: [
    RouterModule.forChild(routes),
    CommonModule
  ],
  exports: [RouterModule]
})
export class CompaniesRoutingModule { }
